import React from "react";

function IconBxlFirebase() {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="currentColor"
      className="h-14 w-14 text-[#f29800] md:h-16 md:w-16"
    >
      <path d="M5.239 15.063L7.21 2.381a.453.453 0 01.847-.145l2.12 3.979-4.938 8.848zM19.24 18.14L17.363 6.469a.454.454 0 00-.766-.246L4.76 18.14l6.55 3.691c.411.23.912.23 1.323 0l6.607-3.691zM13.917 7.955L12.4 5.052a.452.452 0 00-.8 0L4.939 16.989l8.978-9.034z" />
    </svg>
  );
}

export default IconBxlFirebase;
